import { render } from "./ManageSalaries.vue?vue&type=template&id=3d84bd2b&scoped=true"
import script from "./ManageSalaries.vue?vue&type=script&lang=js"
export * from "./ManageSalaries.vue?vue&type=script&lang=js"

import "./ManageSalaries.vue?vue&type=style&index=0&id=3d84bd2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d84bd2b"]])

export default __exports__